import { Chip, styled, Typography } from '@mui/material';
import Accordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Stack } from '@mui/system';
import { Attachment } from 'modules/service-call/types';
import React from 'react';
import { useIntl } from 'react-intl';
import { ServiceCallAttachment } from './ServiceCallAttachment';

interface ServiceCallAttachmentsAccordionProps {
  attachments: Attachment[]
  serviceCallId: string
  noteId: number
}

const StyledAccordion = styled(Accordion)<AccordionProps>(({ theme }) => ({
  '& .MuiAccordionSummary-root': {
    backgroundColor: theme.palette.notes.default,
  }
}));

export const ServiceCallAttachmentsAccordion: React.FC<ServiceCallAttachmentsAccordionProps> = ({ attachments, serviceCallId, noteId }) => {
  const { formatMessage } = useIntl();

  return (
    <StyledAccordion disableGutters>
      <AccordionSummary expandIcon={<ArrowDropDownIcon />}>
        <Stack direction='row' gap={1}>
          <AttachFileIcon sx={{ marginRight: 1 }} />
          <Typography>{formatMessage({ id: 'ServiceCallAttachmentsAccordion.Attachments', defaultMessage: 'Attachments' })}</Typography>
          <Chip size='small' color='primary' label={attachments.length} />
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Stack gap={1}>
          {attachments.map(attachment => <ServiceCallAttachment key={attachment.fileName} attachment={attachment} serviceCallId={serviceCallId} noteId={noteId} />)}
        </Stack>
      </AccordionDetails>
    </StyledAccordion>
  );
};